import cookie from "js-cookie";
import uuid from './uuid'

/* ****** 获取token ****** */

// getToken
export function getToken(key) {
	return cookie.get(key) || '';
}

export function setCookie(key, value) {
	cookie.set(key, value, {
		expires: 20 / 60 / 24
	});
}
//delete token
export function deleteToken(key) {
	return cookie.set(key, '', {
		expires: -1
	})
}

// saveToken
export function saveToken(key) {
	const queryToken = getUrlQuery(key);

	// 隐藏token
	setUrlQuery(key, '', true)

	const token = queryToken || cookie.get(key) || '';

	cookie.set(key, token, {
		expires: 20 / 60 / 24
	});
}


export function hasLogin() {
	return getToken('sk') !== ''
}

/* ****** 获取fingerPrint 已废弃 ****** */

// 暂时使用uuid代替 可考虑Fingerprintjs2

export function getFingerPrint() {
	// 从本地获取已有fp
	let fp = cookie.get('fp')

	if (!fp) {
		fp = uuid()
		cookie.set('fp', fp, {
			expires: 3650
		})
	}

	return fp
}

/* ****** url解析相关方法 ****** */
// 解析Url参数
export function parseUrlQuery() {
	let { search, hash } = window.location

	const queryJson = {}

	if (!search && hash.indexOf('?') !== -1) {
		search = '?' + hash.split('?')[1];
	} else if (search && hash.indexOf('?') !== -1) {
		search = search + '&' + hash.split('?')[1]
	}
	search = decodeURIComponent(search)
	if (search.endsWith("=")) {
		search = search.slice(0, search.length - 1)
	}

	let query = search.match(/([?&])[^&]+/ig);
	if (query) {
		query.forEach(function (str) {
			let arr;
			str = str.substring(1);
			str = str.replace(/=/, '==');
			arr = str.split('==');
			queryJson[arr[0]] = arr[1] ? arr[1] : ''
		})
	}

	return queryJson
}


/**
 * 兼容锐捷1000设备的取参方式
 * @returns object
 */
 export const analyzeCustomQuery = function() {
	let search = window.location
        .search
        .substring(1);
    let searchList = search.split('/')
    let searchObj = {};
    try {
        searchList.forEach((x, i) => {
            let xList = '';

            xList = x
                .replace(/%7C|\|/gi, '#')
                .split('#');

            searchObj[xList[0]] = xList[1];
        });
    } catch (error) {}

	return searchObj;
}


// 获取相应参数
export function getUrlQuery(key) {
	const { search } = window.location;
	let queryJson = {};
	if (search) {
		let decodeSearch = decodeURIComponent(search);
    if (isNonStandardUrlSearch(decodeSearch)) {
			queryJson = analyzeCustomQuery();
    } else {
			queryJson = parseUrlQuery();
    }

		// if (decodeSearch.indexOf('=') > -1) {
		// 	queryJson = parseUrlQuery();
		// } else {
		// 	queryJson = analyzeCustomQuery();
		// }
	}

	return queryJson[key]
}

// 获取相应参数
export function getUrlQueryJSON() {
	const { search } = window.location;
	let queryJson = {};
	if (search) {
		let decodeSearch = decodeURIComponent(search);
		if (decodeSearch.indexOf('=') > -1) {
			queryJson = parseUrlQuery();
		} else {
			queryJson = analyzeCustomQuery();
		}
	}


	return queryJson
}

// 不对url进行decodeURIComponent解析直接获取参数，保证通过一次即可获取完整的portal
export function unParseEecodeQuery() {
	let { search, hash } = window.location

	const queryJson = {}

	if (!search && hash.indexOf('?') !== -1) {
		search = '?' + hash.split('?')[1];
	} else if (search && hash.indexOf('?') !== -1) {
		search = search + '&' + hash.split('?')[1]
	}
	if (search.endsWith("=")) {
		search = search.slice(0, search.length - 1)
	}

	let query = search.match(/([?&])[^&]+/ig);
	if (query) {
		query.forEach(function (str) {
			let arr;
			str = str.substring(1);
			str = str.replace(/=/, '==');
			arr = str.split('==');
			queryJson[arr[0]] = arr[1] ? arr[1] : ''
		})
	}

	return queryJson
}

// 获取未decodeURIComponent的相应参数
export function getUnEecodeUrlQuery(key) {
	const queryJson = unParseEecodeQuery()
	return queryJson[key]
}

// 添加相应参数
export function setUrlQuery(key, value, isDelete) {
	const queryJson = parseUrlQuery()

	let {
		hash,
		origin,
		pathname
	} = window.location

	if (isDelete) {
		delete queryJson[key]
	} else {
		queryJson[key] = value
	}

	let newSearch = Object.entries(queryJson).map(([key, value]) => {
		return `${key}=${value}`
	}).join('&')

	if (newSearch) newSearch = '?' + newSearch

	window.history.replaceState({}, '', origin + pathname + newSearch + hash.split('?')[0]);
}


export function getPathQueryString({path = ''}) {
  let result = {},
      reg1 = /([^?=&#]+)=([^?=&#]+)/g,
      reg2 = /#([^?=&#]+)/g
  path.replace(reg1, (n, x, y) => (result[x] = y))
  path.replace(reg2, (n, x) => (result['HASH'] = x))

  return result
}




function isNonStandardUrlSearch(search) {
    // 1. 获取当前 URL 的查询字符串部分

    // 2. 检查查询字符串是否存在且不为空
    if (!search || search.length <= 1) {
        return false;
    }

    // 3. 移除开头的 '?' 符号，只保留参数部分
    const paramsString = search.substring(1);

    // 4. 检查是否包含第一种规则的特征：
    //    a) 必须包含至少一个竖线 '|' (键值连接符)
    //    b) 必须包含至少一个斜杠 '/' (参数分隔符)
    
    // 注意：我们假设如果 URL 满足这种非标准格式，它通常会有多个参数，
    // 因此 '|' 和 '/' 都会出现。

    const hasPipe = paramsString.includes('|');
    const hasSlash = paramsString.includes('/');

    // 如果同时包含 '|' 和 '/'，我们判断为满足第一种非标准规则。
    // 这与标准的 key=value&key=value 格式形成鲜明对比。
    if (hasPipe && hasSlash) {
        return true;
    }
    
    // 如果只有 '|' (即只有一个参数，例如: ?roam|1)，也应视为第一种格式。
    if (hasPipe && !hasSlash) {
         return true;
    }

    // 兜底返回 false
    return false;
}
